import loadable from '@loadable/component';

export const CmsRichTextBlockLoadable = loadable(
  () => import('./CmsRichTextBlock'),
  { resolveComponent: (module) => module.CmsRichTextBlock },
);
